import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const handleNavClick = (e) => {
    const href = e.target.getAttribute('href');
    
    // Handle external links
    if (href && (href.includes('youtube.com') || href.includes('spotify.com') || href.includes('instagram.com'))) {
      return;
    }
    
    // Handle internal anchor links
    if (href && href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setIsMobileMenuOpen(false);
      }
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <img 
            src="https://cloud-1de12d.becdn.net/media/original/e591e3e2bed001f494d50adc4ad59290.png" 
            alt="Point Makers Podcast" 
            className="logo-img" 
            loading="lazy" 
          />
        </div>
        
        <button 
          className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`} 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
          aria-label="Toggle menu" 
          aria-expanded={isMobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <nav className={`nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <a href="#home" className="nav-link" onClick={handleNavClick}>
            Home
          </a>
          <a href="#episodes" className="nav-link" onClick={handleNavClick}>
            Episodes
          </a>
          <a href="#about" className="nav-link" onClick={handleNavClick}>
            About
          </a>
          <a href="#guest" className="nav-link" onClick={handleNavClick}>
            Be a Guest
          </a>
          <a href="#sponsors" className="nav-link" onClick={handleNavClick}>
            Sponsor
          </a>
          <a href="https://youtube.com/@pointmakerspodcast?si=khoIm_WB-cYQAAql" className="nav-link" onClick={handleNavClick} target="_blank" rel="noopener noreferrer">
            Watch
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;